let html = `<div class="activity layer--width">
    <div class="activity__body"></div>
    <div class="activity__loader"></div>
</div>`

export default html